import React, { useState } from 'react';
import { renderQuestions } from '../questions';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import toastr from 'toastr';

import LoadingButton from '../../../../components/loading_button/LoadingButton';

const StepQuestions = ({ 
                        handleChange, 
                        handleBlur, 
                        values, 
                        touched, 
                        errors, 
                        setFieldValue,
                        isLoading}) => {
  const [step, setStep] = useState(0);
  const { surveyUserForm } = useSelector(state => state.surveyUserForm);
  const nextStep = () => {
    if (!surveyUserForm?.allowSkippingQuestions && step !== 0) {
      const currentValue = values[`question_${step -1}`];
      const currentError = errors[`question_${step -1}`];
      if (!currentValue || currentError ||
          (typeof currentValue === 'string' && currentValue.trim() === '') || 
          (Array.isArray(currentValue) && currentValue.length === 0)) {
            toastr.error('Debes responder la pregunta para continuar');
        return;
      }
    }
    setStep((prev) => prev + 1);
  }
  const prevStep = () => {
    setStep((prev) => prev - 1);
  }
  return (
    <div className="mt-5">
      {
        step === 0 && (
          <div className="mt-2">
            {
              surveyUserForm?.photo && 
              <img src={`${process.env.REACT_APP_URL}${surveyUserForm?.photo}`} className="img-fluid" alt="survey" />
            }
            <h1 className="display-2 mt-5">{ surveyUserForm?.name }</h1>
            <p className="my-3">{ surveyUserForm?.description }</p>
          </div>
        )
      }
      {
        surveyUserForm?.questions.map((question, index) => (
          step === (index + 1) && (
            renderQuestions(question, index, handleChange, handleBlur, values, touched, errors, setFieldValue)
          )
        ))
      }
     {/*  {
        step === (questions.length + 1) && (
          surveyUserFormEndMessage && <p className="mb-4">surveyUserFormEndMessage</p>
        )
      } */}
      <div className="d-flex justify-content-between mb-5">
        <Button 
          className={step === 0 ? 'd-none' : '' || step === (surveyUserForm?.questions.length + 1) || (!surveyUserForm?.allowSkippingQuestions && step !== 0) ? 'd-none' : ''}
          //disabled={step === 0}
          variant="secondary" 
          onClick={prevStep}>Anterior</Button>
        <Button
          className={step === surveyUserForm?.questions.length ? 'd-none' : ''}
          //disabled={step === (questions.length + 1)}
          variant="secondary" 
          onClick={nextStep}>{step === 0 ? 'Iniciar' : 'Siguiente'}</Button>
        {
          step === surveyUserForm?.questions.length &&
          <LoadingButton
              isLoading={isLoading}
              text="Enviar"
              variant="primary"
              type="submit"
              disabled={isLoading} 
              />
        }
      </div>
    </div>
  )
}

export default StepQuestions;